<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.invoiceApplyRecord')"
    :batch-actions="batchActions"
    resource="invoice_apply_records"
    :actionColumnProps="{ width: 180 }"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/invoice_apply_records.js';
import _ from 'lodash';

@Component
export default class InvoiceApplyRecords extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'state_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      {
        key: 'invoice_type',
        width: 140,
      },
      {
        key: 'title_type',
        width: 80,
      },
      {
        key: 'state',
        width: 100,
      },
      'user',
      'apply_record',
      'title',
      'tax_number',
      'bank_name',
      'bank_account',
      'company_address',
      'telephone',
      'remark',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'remark',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      row.state === 'pending' && {
        component: 'confirmButton',
        props: {
          label: '处理',
          type: 'primary',
          can: 'invoice_apply_records.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/invoice_apply_records/${row.id}/process`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.state === 'processing' && {
        component: 'confirmButton',
        props: {
          label: '完成',
          type: 'primary',
          can: 'invoice_apply_records.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/invoice_apply_records/${row.id}/finish`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'invoice_apply_records.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'invoice_apply_records.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>导出</el-button>
    ];
  }
}

export const route = [
  {
    path: '/invoice_apply_records',
    name: 'invoice_apply_records.index',
    component: InvoiceApplyRecords,
    props: {
      type: 'index',
    }
  },
  {
    path: '/invoice_apply_records/new',
    name: 'invoice_apply_records.new',
    component: InvoiceApplyRecords,
    props: {
      type: 'new',
    }
  },
  {
    path: '/invoice_apply_records/:id',
    name: 'invoice_apply_records.show',
    component: InvoiceApplyRecords,
    props: {
      type: 'show',
    }
  },
  {
    path: '/invoice_apply_records/:id/edit',
    name: 'invoice_apply_records.edit',
    component: InvoiceApplyRecords,
    props: {
      type: 'edit'
    }
  }
]
</script>
